module.exports = __webpack_public_path__ + "img/32671e9.svg";